import React from "react";
import "./ShopPage.css";
const ShopPageHead = () => {
  return (
    <div className="shopPageHead">
      <h1>Best Hair Treatment Products</h1>
      <div className="shopUnderLine"></div>
    </div>
  );
};

export default ShopPageHead;
